import { t as e } from "./utils-DiFe-_ei.js";
import { Button as t } from "./foundations/button.js";
import "./button-C8zrAH2m.js";
import { t as n } from "./createLucideIcon-CJLgHpqc.js";
import { t as r } from "./check-hnLqiRGn.js";
import { t as i } from "./chevron-down-D8vOGVnQ.js";
import { t as a } from "./x-DCbCFsrz.js";
import { t as o } from "./checkbox-BNSdvisy.js";
import "./checkbox-9kLtro67.js";
import { Popover as s, PopoverContent as c, PopoverTrigger as l } from "./foundations/popover.js";
import "./popover-CcWt3azL.js";
import { Dialog as u, DialogContent as d, DialogFooter as f, DialogHeader as p, DialogTitle as m } from "./foundations/dialog.js";
import "./dialog-DGSJCBAd.js";
import { Typography as h } from "./foundations/typography.js";
import "./typography-CTPDhvds.js";
import { a as g, i as _, n as v, o as y, r as b, s as x, t as S } from "./command-Bd6gcY9v.js";
import { useEffect as C, useRef as w, useState as T } from "react";
import { Fragment as E, jsx as D, jsxs as O } from "react/jsx-runtime";
var k = n("plus", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}], ["path", {
	d: "M12 5v14",
	key: "s699le"
}]]), A = n("tag", [["path", {
	d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
	key: "vktsd0"
}], ["circle", {
	cx: "7.5",
	cy: "7.5",
	r: ".5",
	fill: "currentColor",
	key: "kqv944"
}]]);
//#endregion
//#region src/components/tags/TagPill/TagPill.tsx
function j(e) {
	let t = parseInt(e.slice(1, 3), 16), n = parseInt(e.slice(3, 5), 16), r = parseInt(e.slice(5, 7), 16);
	return (.2126 * t + .7152 * n + .0722 * r) / 255 > .5 ? "text-black" : "text-white";
}
function M({ name: t, color: n, className: r }) {
	return /* @__PURE__ */ D(h, {
		variant: "label",
		as: "span",
		className: e("inline-flex items-center overflow-hidden rounded-full px-2 py-0.5", n ? j(n) : "bg-stone-100 text-stone-600", r),
		style: n ? { backgroundColor: n } : void 0,
		children: /* @__PURE__ */ D("span", {
			className: "truncate",
			children: t
		})
	});
}
//#endregion
//#region src/components/tags/tags.constants.ts
var N = [
	"#3b82f6",
	"#22c55e",
	"#f97316",
	"#ef4444",
	"#a855f7",
	"#ec4899",
	"#14b8a6",
	"#eab308",
	"#6366f1",
	"#64748b",
	"#10b981",
	"#f43f5e"
], P = 50, F = /^#[0-9a-fA-F]{6}$/;
function I({ tags: n, value: o, onChange: u, onCreateTag: d, label: f = "Add tag", disabled: p = !1, className: m, variant: C = "form" }) {
	let [w, j] = T(!1), [I, L] = T(""), [R, z] = T(null), [B, V] = T(void 0), [H, U] = T(""), [W, G] = T(!1), K = n.filter((e) => o.includes(e.id)), q = C === "filter" && f === "Add tag" ? "Tags" : f;
	function J(e) {
		o.includes(e) ? u(o.filter((t) => t !== e)) : u([...o, e]), j(!1);
	}
	let Y = I.trim(), X = d !== void 0 && Y.length > 0 && !n.some((e) => e.name.toLowerCase() === Y.toLowerCase()), Z = Y.length, ee = Z >= P - 10, te = Z >= P;
	async function ne() {
		if (!(!R || !d)) {
			G(!0);
			try {
				await d(R.name, B);
			} finally {
				G(!1), z(null), V(void 0), U(""), L(""), j(!1);
			}
		}
	}
	function Q() {
		z(null), V(void 0), U("");
	}
	function re(e) {
		V(e), U(e);
	}
	function ie() {
		let e = H.toLowerCase();
		F.test(e) && (U(e), V(e));
	}
	let $ = o.length;
	return /* @__PURE__ */ O("div", {
		className: e(C === "form" ? "space-y-2" : void 0, m),
		children: [C === "form" && K.length > 0 && !w && /* @__PURE__ */ D("div", {
			className: "flex flex-wrap gap-1.5",
			children: K.map((e) => /* @__PURE__ */ D("button", {
				type: "button",
				onClick: () => j(!0),
				className: "cursor-pointer appearance-none",
				children: /* @__PURE__ */ D(M, {
					name: e.name,
					color: e.color
				})
			}, e.id))
		}), /* @__PURE__ */ O(s, {
			open: w,
			onOpenChange: (e) => {
				j(e), e || (z(null), V(void 0), U(""));
			},
			children: [/* @__PURE__ */ D(l, {
				asChild: !0,
				children: C === "filter" ? /* @__PURE__ */ O(t, {
					variant: "outline",
					size: "sm",
					disabled: p,
					className: e("h-9 gap-2 rounded-lg px-3 font-normal", $ === 0 && "text-muted-foreground"),
					children: [
						/* @__PURE__ */ D(A, {
							className: "size-4 shrink-0",
							"aria-hidden": "true"
						}),
						$ > 0 ? `Tags (${$})` : q,
						/* @__PURE__ */ D(i, {
							className: "size-4 shrink-0",
							"aria-hidden": "true"
						})
					]
				}) : /* @__PURE__ */ O(t, {
					variant: "ghost",
					size: "sm",
					disabled: p,
					className: "text-muted-foreground hover:text-foreground h-7 gap-1 px-2 text-xs",
					children: [/* @__PURE__ */ D(k, {
						className: "h-3 w-3",
						"aria-hidden": "true"
					}), f]
				})
			}), /* @__PURE__ */ D(c, {
				className: "w-64 p-0",
				align: "start",
				children: R ? /* @__PURE__ */ O("div", {
					className: "space-y-3 p-3",
					children: [
						/* @__PURE__ */ O("div", {
							className: "flex items-center justify-between",
							children: [/* @__PURE__ */ D(h, {
								variant: "body",
								className: "font-medium",
								children: "Pick a color"
							}), /* @__PURE__ */ D("button", {
								onClick: Q,
								className: "text-muted-foreground hover:text-foreground transition-colors",
								"aria-label": "Cancel",
								children: /* @__PURE__ */ D(a, { className: "h-4 w-4" })
							})]
						}),
						/* @__PURE__ */ O(h, {
							variant: "body-sm",
							color: "muted",
							truncate: !0,
							className: "max-w-full",
							children: [
								"“",
								R.name,
								"”"
							]
						}),
						/* @__PURE__ */ O("div", {
							className: "flex flex-wrap gap-2",
							children: [/* @__PURE__ */ D("button", {
								onClick: () => {
									V(void 0), U("");
								},
								className: e("flex size-6 items-center justify-center rounded-full border border-stone-300 bg-stone-100 ring-offset-1 transition-shadow", B === void 0 ? "ring-2 ring-stone-900" : "hover:ring-2 hover:ring-stone-400"),
								title: "No color",
								"aria-label": "No color",
								children: /* @__PURE__ */ D(a, { className: "h-3 w-3 text-stone-400" })
							}), N.map((t) => /* @__PURE__ */ D("button", {
								onClick: () => re(t),
								className: e("size-6 rounded-full ring-offset-1 transition-shadow", B === t ? "ring-2 ring-stone-900" : "hover:ring-2 hover:ring-stone-400"),
								style: { backgroundColor: t },
								title: t,
								"aria-label": t
							}, t))]
						}),
						/* @__PURE__ */ D("input", {
							type: "text",
							value: H,
							placeholder: "#000000",
							onChange: (e) => U(e.target.value),
							onBlur: ie,
							className: "w-full rounded-md border px-2 py-1 font-mono text-base md:text-sm",
							"aria-label": "Hex colour"
						}),
						/* @__PURE__ */ O("div", {
							className: "flex gap-2",
							children: [/* @__PURE__ */ D(t, {
								size: "sm",
								className: "flex-1",
								onClick: () => void ne(),
								disabled: W,
								children: W ? "Creating…" : "Create tag"
							}), /* @__PURE__ */ D(t, {
								size: "sm",
								variant: "outline",
								onClick: Q,
								children: "Cancel"
							})]
						})
					]
				}) : /* @__PURE__ */ O(S, { children: [
					/* @__PURE__ */ D(_, {
						placeholder: "Search tags…",
						value: I,
						onValueChange: (e) => {
							e.length <= P && L(e);
						}
					}),
					Z > 0 && /* @__PURE__ */ O("div", {
						className: e("px-3 py-1 text-right text-[11px]", te ? "text-destructive-text" : ee ? "text-amber-500" : "text-muted-foreground"),
						children: [
							Z,
							"/",
							P
						]
					}),
					/* @__PURE__ */ O(y, { children: [
						/* @__PURE__ */ D(v, { children: "No tags found." }),
						/* @__PURE__ */ D(b, { children: n.map((t) => /* @__PURE__ */ O(g, {
							value: t.name,
							onSelect: () => J(t.id),
							children: [
								/* @__PURE__ */ D(r, {
									className: e("mr-2 h-4 w-4 shrink-0", o.includes(t.id) ? "opacity-100" : "opacity-0"),
									"aria-hidden": "true"
								}),
								t.color && /* @__PURE__ */ D("span", {
									className: "mr-1.5 inline-block h-2 w-2 shrink-0 rounded-full",
									style: { backgroundColor: t.color },
									"aria-hidden": "true"
								}),
								/* @__PURE__ */ D("span", { children: t.name })
							]
						}, t.id)) }),
						X && /* @__PURE__ */ O(E, { children: [/* @__PURE__ */ D(x, {}), /* @__PURE__ */ D(b, { children: /* @__PURE__ */ O(g, {
							value: `__create__${Y}`,
							onSelect: () => {
								z({ name: Y }), V(void 0);
							},
							children: [/* @__PURE__ */ D(k, {
								className: "mr-2 h-4 w-4 shrink-0",
								"aria-hidden": "true"
							}), `Create "${Y}"`]
						}) })] })
					] })
				] })
			})]
		})]
	});
}
//#endregion
//#region src/components/tags/BulkTagPicker/BulkTagPicker.tsx
function L(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let t of e) n.set(t, "add");
	for (let e of t) n.set(e, "unchanged");
	return n;
}
function R({ open: e, onOpenChange: n, allTags: r, allSelectedTagIds: i, someSelectedTagIds: a, onApply: s, isApplying: c = !1 }) {
	let [l, h] = T(() => L(i, a)), x = w(!1);
	C(() => {
		e && !x.current && h(L(i, a)), x.current = e;
	}, [
		e,
		i,
		a
	]);
	function E(e) {
		h((t) => {
			let n = new Map(t);
			return n.get(e) === "add" ? n.set(e, "remove") : n.set(e, "add"), n;
		});
	}
	function k(e) {
		let t = l.get(e);
		return t === "add" || t === "unchanged" && "indeterminate";
	}
	function A() {
		s([...l.entries()].filter(([, e]) => e === "add").map(([e]) => e), [...l.entries()].filter(([, e]) => e === "remove").map(([e]) => e));
	}
	function j() {
		h(L(i, a)), n(!1);
	}
	return /* @__PURE__ */ D(u, {
		open: e,
		onOpenChange: n,
		children: /* @__PURE__ */ O(d, {
			className: "max-w-sm",
			children: [
				/* @__PURE__ */ D(p, { children: /* @__PURE__ */ D(m, { children: "Assign tags" }) }),
				/* @__PURE__ */ O(S, { children: [/* @__PURE__ */ D(_, { placeholder: "Search tags…" }), /* @__PURE__ */ O(y, { children: [/* @__PURE__ */ D(v, { children: "No tags found." }), /* @__PURE__ */ D(b, { children: r.map((e) => /* @__PURE__ */ O(g, {
					value: e.name,
					onSelect: () => E(e.id),
					className: "gap-2",
					children: [
						/* @__PURE__ */ D(o, {
							checked: k(e.id),
							onCheckedChange: () => {},
							"aria-label": e.name,
							tabIndex: -1
						}),
						e.color && /* @__PURE__ */ D("span", {
							className: "inline-block h-2 w-2 shrink-0 rounded-full",
							style: { backgroundColor: e.color },
							"aria-hidden": "true"
						}),
						/* @__PURE__ */ D("span", { children: e.name })
					]
				}, e.id)) })] })] }),
				/* @__PURE__ */ O(f, { children: [/* @__PURE__ */ D(t, {
					variant: "outline",
					onClick: j,
					children: "Cancel"
				}), /* @__PURE__ */ D(t, {
					onClick: A,
					disabled: c,
					children: c ? "Applying…" : "Apply"
				})] })
			]
		})
	});
}
//#endregion
export { k as a, M as i, I as n, N as r, R as t };

//# sourceMappingURL=tags-DvdIozRe.js.map